/* eslint-disable no-restricted-syntax */
// PoC デモページ（このページ限定で no-restricted-syntax を無効化し日本語文言を許可）。
import { LegacyPortalAccountService } from "@spwn-portal/grpc";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { createCrossOriginPrivateConnectClient } from "../../utility/connectWeb";
import {
  contentStyle,
  pageContainerStyle,
  PrimaryButton,
} from "./evojUi";
import { startggConfig } from "./startggConfig";
import { useStartggLink } from "./useStartggLink";

type Phase = "processing" | "done" | "error";

// authorization code は1回限り・短命。callback の再マウントで2回交換して失敗するのを、
// module スコープのガードで防ぐ（コンポーネント再マウントでも保持される）。
let processedCode: string | null = null;

/**
 * start.gg OAuth の callback ルート（redirect_uri = /account/startgg/callback）。
 * ?code&state を受け、cross-origin(include) クライアントで ExchangeStartggCode を呼ぶ。
 * state の照合は backend が sgst cookie と突合して行う（フロントは state を保持しない）。
 */
export const StartggCallback: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const client = useMemo(
    () => createCrossOriginPrivateConnectClient(LegacyPortalAccountService),
    []
  );
  const { save } = useStartggLink();
  const [phase, setPhase] = useState<Phase>("processing");
  const [message, setMessage] = useState("start.gg と連携しています…");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!code || !state) {
      setPhase("error");
      setMessage("code または state がありません");
      return;
    }
    if (processedCode === code) {
      return;
    }
    processedCode = code;

    void (async () => {
      try {
        const res = await client.exchangeStartggCode({
          code,
          redirectUri: startggConfig.redirectUri,
          state,
        });
        save({
          userId: res.startggUserId,
          username: res.startggUsername,
          linkedAt: Date.now(),
        });
        setPhase("done");
        setMessage(`連携しました：${res.startggUsername}`);
        setTimeout(() => history.replace("/evoj/entry"), 800);
      } catch (e) {
        console.error(e);
        setPhase("error");
        setMessage("連携に失敗しました");
      }
    })();
  }, [client, history, location.search, save]);

  return (
    <div style={pageContainerStyle}>
      <div style={contentStyle}>
        <h1>start.gg 連携</h1>
        <p>{message}</p>
        {phase === "error" && (
          <PrimaryButton onClick={() => history.replace("/evoj/entry")}>
            戻る
          </PrimaryButton>
        )}
      </div>
    </div>
  );
};
